import { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { hasScreen, saveScreen, deleteScreen } from "./screenStorage";
import { openDialogAction } from "@icarius-common/dialog/actions";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { getUserData } from "@icarius-app/selectors";

const myPeopleDefaultFilters = {
    "PERSONAL DE PLANTA": {
        values: ["Si"],
        filterType: "set",
    },
    ESTADO: {
        values: ["Vigente"],
        filterType: "set",
    },
};

export default function useFixedFilters(screenName) {
    const dispatch = useDispatch();
    const [hasFixedFilters, setHasFixedFilters] = useState(false);
    const [loading, setLoading] = useState(true);
    const user = useSelector(getUserData);
    const role = user.level;
    const code = user.code;

    // Cargar estado desde IndexedDB
    useEffect(() => {
        const load = async () => {
            const exists = await hasScreen(screenName, code, role);
            setHasFixedFilters(exists);
            setLoading(false);
        };

        load();
    }, [screenName, code, role]);

    // Toggle persistido
    const toggleFixedFilters = useCallback(
        async (gridRef, hasTemplateActive) => {
            if (!gridRef?.api) return;

            const exists = await hasScreen(screenName, code, role);

            if (exists) {
                const defaultFilters =
                    screenName === getLocalizedString("employeeMaster") ||
                    screenName === getLocalizedString("myPeopleTableTitle") ||
                    screenName === getLocalizedString("vacationsTitleLong")
                        ? myPeopleDefaultFilters
                        : null;

                const screenId = `${code}__${screenName}`;
                await deleteScreen(screenId);
                setHasFixedFilters(false);

                // Reseteo el estado de la grilla
                gridRef.api.setFilterModel(defaultFilters);
                gridRef.api.onFilterChanged();
            } else {
                if (hasTemplateActive) {
                    dispatch(
                        openDialogAction({
                            title: getLocalizedString("atention"),
                            msg: getLocalizedString("templateNotEmptyWarning"),
                            acceptOnly: true,
                        })
                    );
                    return;
                }

                const data = {
                    filter: gridRef.api.getFilterModel(),
                };

                await saveScreen(screenName, data, code, role);
                setHasFixedFilters(true);
            }
        },
        [dispatch, screenName, code, role]
    );

    return {
        hasFixedFilters,
        loadingFixedFilters: loading,
        toggleFixedFilters,
    };
}
